/** Given a valid Role Requirements questionnaire URL, get its resource identifier */
export const extractQuestionnaireId = (url?: string): string | undefined => {
  const matches = url?.match(/questionnaires\/([0-9a-fA-F\d-]+)\/?/);
  return matches?.[1];
};
